let environment;

if (process.env.VUE_APP_JODIGI_ENV === "test") {
	environment = require("./environment.test").environment;
} else if (process.env.NODE_ENV === "production") {
	environment = require("./environment.prod").environment;
} else {
	environment = require("./environment.dev").environment;
}

export { environment };
